// extracted by mini-css-extract-plugin
module.exports = {"HoverDesc":"HoverDescNode_HoverDesc__1Dc7I","description":"HoverDescNode_description__AqrWE"};